module.exports = __webpack_public_path__ + "img/AO.74cfd7d0.png";